import React from "react";
import Button from "components/lib/Shared/Button";

const Securities = ({ handleSummaryNavigation }) => {
  return (
    <div>
      Securities
      <div className="px-4 py-3 bg-white sm:px-6">
        <div className="flex justify-between space-x-2">
          <Button
            onClick={() => handleSummaryNavigation("prev")}
            className="inline-flex justify-center px-4 py-2 text-sm font-medium text-white bg-gray-500 border border-transparent rounded-md shadow-sm hover:bg-gray-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
          >
            Previous
          </Button>
          <Button
            onClick={() => handleSummaryNavigation("next")}
            className="inline-flex justify-center px-4 py-2 text-sm font-medium text-white bg-sflPrimary border border-transparent rounded-md shadow-sm hover:bg-sflPrimary-dark focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
          >
            Save and proceed
          </Button>
        </div>
      </div>
    </div>
  );
};

export default Securities;
